<header class="header">
  <div class="d-flex w-100 header-container">
    <a class="header__title" [routerLink]="''">Realist user guide</a>
    <ul class="d-flex p-0 nav">
      <li *ngFor="let headerItem of headerRoutes">
        <a class="nav__link" [routerLink]="[headerItem.url, headerItem.subUrl]">{{headerItem.title}}</a>
      </li>
    </ul>
    <section class="d-flex nav-icons-section">
      <a href="https://twitter.com/corelogicres" target="_blank" class="btn-icon">
        <img src="assets/icons/Twitter.svg" alt="Twitter">
        <span class="sr-only">Twitter</span>
      </a>
      <a href="https://www.facebook.com/RealistCoreLogic" target="_blank" class="btn-icon">
        <img src="assets/icons/Facebook.svg" alt="Facebook">
        <span class="sr-only">Facebook</span>
      </a>
      <a href="https://www.linkedin.com/showcase/corelogic-real-estate-solutions/" type="button" class="btn-icon" target="_blank">
        <img src="assets/icons/Linkedin.svg" alt="LinkedIn">
        <span class="sr-only">Linkedin</span>
      </a>
      <a href="https://www.youtube.com/user/RealistCoreLogic?sub_confirmation=1" type="button" class="btn-icon" target="_blank">
        <img src="assets/icons/YouTube.svg" alt="YouTube">
        <span class="sr-only">YouTube</span>
      </a>
    </section>
  </div>
</header>
